import '../../styles.global.css';
import '../../assets/styles/ButtonGroup.module.css';

var styles = {"group":"wru__ButtonGroup__group","wrapper":"wru__ButtonGroup__wrapper","show":"wru__ButtonGroup__show","button":"wru__ButtonGroup__button","spinner":"wru__ButtonGroup__spinner","left":"wru__ButtonGroup__left","center":"wru__ButtonGroup__center","right":"wru__ButtonGroup__right"};

export { styles as default };
//# sourceMappingURL=ButtonGroup.module.scss.js.map
